<ng-template vdrDialogTitle>{{ title | translate }}</ng-template>
<ng-container
  [ngTemplateOutlet]="selectorTemplate"
  [ngTemplateOutletContext]="{ select: resolveWith }"
></ng-container>
